function initAnimatedSvg() {
	try {
		if (document.querySelector('.arrow')) {
			const anim = lottie

			anim.loadAnimation({
				container: document.querySelector('.arrow'),
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: './arrow.json',
			})
		}
	} catch {
	}
}
